// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <v-container fluid grid-list-xs>
    <v-card>
      <v-toolbar flat :class="'title ' + heartbeatColor">
        <v-btn icon @click="exit"><v-icon>clear</v-icon></v-btn>
        Device - {{ item.name }}
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-tabs
      v-model="tab"
      centered
      >
        <v-tab>
          Device
        </v-tab>
        <v-tab>
          Logs
        </v-tab>
        <v-tab-item>
          <v-card-text>
            <v-container fluid grid-list-md>
              <v-layout row wrap>
                <v-flex xs12 md4>
                  <v-text-field
                    label="Device Name"
                    v-model="item.name"
                    @blur="saveName"
                    hide-details
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4 >
                  <table>
                    <tr>
                      <td style="width: 100%;">
                        <v-text-field
                          label="Last Heartbeat Time"
                          v-model="heartbeatDate"
                          color="green"
                          disabled
                          hide-details
                        ></v-text-field>
                      </td>
                      <td>
                        <v-btn icon title="Request Heartbeat" @click="requestHeartbeat">
                          <v-icon>favorite</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </table>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    label="Last Config Time"
                    v-model="configDate"
                    disabled
                    hide-details
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    label="Last Local IP"
                    v-model="item.localIP"
                    disabled
                    hide-details
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    label="Serial"
                    v-model="item.serial"
                    disabled
                    hide-details
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    label="Agent version"
                    v-model="item.agentVersion"
                    disabled
                    hide-details
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 md3>
                  <v-menu offset-y style="width: 100%;">
                    <v-btn slot="activator" style="width: 100%;"><v-icon>keyboard_arrow_down</v-icon>Device</v-btn>
                    <v-list>
                      <v-list-tile @click="requestHeartbeat">
                        <v-list-tile-avatar><v-icon>favorite</v-icon></v-list-tile-avatar>
                        <v-list-tile-title>Request Heartbeat</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile @click="requestReboot">
                        <v-list-tile-avatar><v-icon>replay</v-icon></v-list-tile-avatar>
                        <v-list-tile-title>Reboot</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile @click.stop="showDeleteDialog = true">
                        <v-list-tile-avatar><v-icon>delete</v-icon></v-list-tile-avatar>
                        <v-list-tile-title>Delete Device</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </v-flex>

                <v-flex xs12 md3>
                  <v-menu offset-y style="width: 100%;">
                    <v-btn slot="activator" style="width: 100%;"><v-icon>keyboard_arrow_down</v-icon>Debug</v-btn>
                    <v-list>
                      <v-list-tile @click="requestLogs" color="success">
                        <v-list-tile-avatar><v-icon>cloud_download</v-icon></v-list-tile-avatar>
                        <v-list-tile-title>Request Logs</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile @click="requestADBState(true)" color="success">
                        <v-list-tile-avatar><v-icon>add_to_queue</v-icon></v-list-tile-avatar>
                        <v-list-tile-title>Enable ADB</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile @click="requestADBState(false)" color="error">
                        <v-list-tile-avatar><v-icon>remove_from_queue</v-icon></v-list-tile-avatar>
                        <v-list-tile-title>Disable ADB</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </v-flex>

                <v-flex xs12 md3>
                  <v-menu offset-y style="width: 100%;">
                    <v-btn slot="activator" style="width: 100%;"><v-icon>keyboard_arrow_down</v-icon>Notify</v-btn>
                    <v-list>
                      <v-list-tile @click.stop="showEmailDialog = true">
                        <v-list-tile-avatar><v-icon>email</v-icon></v-list-tile-avatar>
                        <v-list-tile-title>Add Email</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </v-flex>
                <v-flex xs12 md3>
                  <v-btn color="success" dark @click.stop="showAddPackage()" style="width: 100%;">Add Application</v-btn>
                </v-flex>
              </v-layout>

              <v-layout row wrap>
                <v-flex xs12 md3>
                  <v-switch
                    label="Auto Timeout Required"
                    v-model="item.config.autoTimeout"
                    @change="saveConfig"
                    hide-details
                  ></v-switch>
                </v-flex>
                <v-flex xs12 md3>
                  <v-switch
                    label="Camera Disabled"
                    v-model="item.config.cameraDisabled"
                    @change="saveConfig"
                    hide-details
                  ></v-switch>
                </v-flex>
                <v-flex xs12 md3>
                  <v-switch
                    label="Keyguard Disabled"
                    v-model="item.config.keyguardDisabled"
                    @change="saveConfig"
                    hide-details
                  ></v-switch>
                </v-flex>
                <v-flex xs12 md3>
                  <v-switch
                    label="Muted"
                    v-model="item.config.masterVolumeMuted"
                    @change="saveConfig"
                    hide-details
                  ></v-switch>
                </v-flex>
                <v-flex xs12 md3>
                  <v-switch
                    label="Screenshots disabled"
                    v-model="item.config.screenshotsDisabled"
                    @change="saveConfig"
                    hide-details
                  ></v-switch>
                </v-flex>
                <v-flex xs12 md3>
                  <v-switch
                    label="Status Bar Disabled"
                    v-model="item.config.statusBarDisabled"
                    @change="saveConfig"
                    hide-details
                  ></v-switch>
                </v-flex>
                <v-flex xs12 md3>
                  <v-switch
                    label="Unknown Sources Disabled"
                    v-model="item.config.unknownSourcesDisabled"
                    @change="saveConfig"
                    hide-details
                  ></v-switch>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex xs12>
                <v-data-table
                  v-bind:headers="headers"
                  :items="this.item.config.applications"
                  :loading="loading"
                  :search="searchText"
                  :rows-per-page-items="[10, 25, { text: 'All', value: -1 }]"
                  no-data-text="No Applications Installed"
                  >
                  <template slot="items" slot-scope="props">
                  <td>
                    {{ props.item.app_name }}
                  </td>
                  <td>
                    {{ props.item.app_version }}
                  </td>
                  <td class="text-xs-left">
                    <v-checkbox
                    v-model="props.item.config.installed"
                    hide-details
                    disabled
                    ></v-checkbox>
                  </td>
                  <td class="text-xs-left">
                    <v-checkbox
                    v-model="props.item.config.kioskMode"
                    hide-details
                    disabled
                    ></v-checkbox>
                  </td>
                  <td class="justify-center layout px-0">
                    <v-btn title="Edit" icon flat @click="editPackage(props.item)"><v-icon>edit</v-icon></v-btn>
                    <v-btn title="Delete" icon flat @click="deletePackage(props.item.app_name, props.item.appkey)"><v-icon>delete</v-icon></v-btn>
                  </td>
                  </template>
                </v-data-table>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12>
                <v-data-table
                  v-bind:headers="emailHeaders"
                  :items="this.item.notificationEmails"
                  :loading="loading"
                  :rows-per-page-items="[10, 25, { text: 'All', value: -1 }]"
                  no-data-text="No Email Notifications">
                  <template slot="items" slot-scope="props">
                  <td>
                    {{ props.item }}
                  </td>
                  <td style="width: 1%; padding: 0px;">
                    <v-btn title="Delete" icon flat @click="deleteEmail(props.item)"><v-icon>delete</v-icon></v-btn>
                  </td>

                  </template>
                </v-data-table>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-tab-item>
        <v-tab-item>
          <v-toolbar flat>
            <v-btn flat color="success" @click="requestLogs">
              <v-icon class="mr-2">cloud_download</v-icon>Request Logs
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn icon @click="refreshLogs" title="Refresh"><v-icon>refresh</v-icon></v-btn>
          </v-toolbar>
          <item-list
          allowDelete
          editRoute="logView"
          :endpoint="logsEndpoint"
          :filter="filter"
          :headers="logHeaders"
          :loadData="logsLoadData"
          name="Device"
          noDataText="Retrieving Data"
          ></item-list>
        </v-tab-item>
      </v-tabs>

    </v-card>
    <v-btn fab dark class="primary" id="addButton" @click="pushConfig"><v-icon>send</v-icon></v-btn>

    <v-dialog v-model="showAddDialog" max-width="500px">
      <v-card>
        <v-card-title>
          Save Application
        </v-card-title>
        <v-card-text>
          <v-text-field
            label="Package Name"
            v-model="newPackage.package"
          ></v-text-field>
          <v-text-field
            label="URI"
            v-model="newPackage.uri"
          ></v-text-field>
          <v-text-field
            label="Version"
            v-model="newPackage.app_version"
          ></v-text-field>
          <v-checkbox
          v-model="newPackage.config.kioskMode"
          label="Kiosk Mode"
          ></v-checkbox>
        </v-card-text>
      <v-card-actions>
        <v-btn color="primary" flat @click.stop="addPackage">Save</v-btn>
        <v-btn color="error" flat @click.stop="showAddDialog=false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDeleteDialog" max-width="500px">
      <v-card>
        <v-card-title>
          Delete Device
        </v-card-title>
        <v-card-text>
          Are you sure you want to delete this device? <b>You must make sure no applications are in kiosk mode.</b>
        </v-card-text>
      <v-card-actions>
        <v-btn color="error" flat @click.stop="deleteDevice">Delete</v-btn>
        <v-btn flat @click.stop="showDeleteDialog=false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDeleteAppDialog" max-width="500px">
      <v-card>
        <v-card-title>
          Delete Application
        </v-card-title>
        <v-card-text>
          Send delete message for application, or just remove it from config?
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" flat @click.stop="uninstallPackage(deleteAppKey)">Send message</v-btn>
          <v-btn flat @click.stop="showDeleteAppDialog=false">Just remove</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showEmailDialog" max-width="500px">
      <v-card>
        <v-card-title>
          Add Email Notification
        </v-card-title>
        <v-card-text>
          <v-text-field
            label="Email Address"
            v-model="newEmail">
          </v-text-field>
        </v-card-text>
        <v-card-actions>
        <v-btn color="error" flat @click.stop="addEmail(newEmail)">Add</v-btn>
        <v-btn flat @click.stop="showEmailDialog=false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <error-snackbar v-model="errorText"></error-snackbar>
  </v-container>
</template>


<script>
  import moment from 'moment'
  import ErrorSnackbar from 'vue-common/components/ErrorSnackbar'
  import ItemList from 'vue-common/components/ItemList.vue'

  import {ENDPOINT} from '@/shared/constants'
  import {AXIOSAPI} from 'vue-common/components/requests-common'

  export default {
    components: {
      ItemList,
      ErrorSnackbar
    },

    data () {
      return {
        errorText: '',
        headers: [
          {
            text: 'Package',
            value: 'package',
            align: 'left'
          },
          {
            text: 'Version',
            value: 'app_version',
            align: 'left'
          },
          {
            text: 'Installed',
            value: 'installed',
            align: 'left'
          },
          {
            text: 'Kiosk Mode',
            value: 'kioskMode',
            align: 'left'
          },
          {
            text: 'Actions',
            value: 'name',
            sortable: false
          }
        ],
        emailHeaders: [
          {
            text: 'Email Address',
            value: 'email',
            align: 'left'
          }
        ],
        logHeaders: [
          {
            text: 'ID',
            value: 'id'
          },
          {
            text: 'Timestamp',
            value: 'timestamp',
            function: this.formatTime
          }
        ],
        item: {
          config: {
            applications: []
          },
          notificationEmails: []
        },
        loading: false,
        newPackage: {
          config: {
            kioskMode: false
          },
          uri: '',
          package: '',
          app_version: ''
        },
        newEmail: '',
        emptyPackage: this.newPackage,
        logsEndpoint: ENDPOINT + 'files',
        logsLoadData: true,
        searchText: '',
        showAddDialog: false,
        showDeleteDialog: false,
        showDeleteAppDialog: false,
        showEmailDialog: false,
        deleteAppKey: '',
        deleteAppPackage: '',
        tab: null
      }
    },

    created () {
      this.getData()
      this.emptyPackage = this.newPackage
    },

    computed: {
      filter: function () {
        var filter = []
        filter.push({
          name: 'tags',
          value: this.$route.params.id
        })
        return filter
      },

      heartbeatDate: function () {
        return moment(this.item.date).format('YYYY-MM-DD hh:mm:ss a')
      },

      heartbeatColor: function () {
        if (moment(this.item.date) > moment().subtract(30, 'minutes')) {
          return 'green lighten-3'
        } else {
          return 'red lighten-3'
        }
      },

      configDate: function () {
        return moment(this.item.last_config_date).format('YYYY-MM-DD hh:mm:ss a')
      }
    },

    methods: {
      deleteDevice: function () {
        var query = ENDPOINT + 'v1/managedevices/' + this.$route.params.id
        AXIOSAPI.delete(query).then(response => {
          this.exit()
        }).catch(e => {
          this.errorText = 'Delete failed: ' + e
        })
      },

      exit: function () {
        this.$router.go(-1)
      },

      formatTime: function (metadata) {
        return moment(metadata.timestamp).format('YYYY-MM-DD hh:mm a')
      },

      getData: function () {
        this.loading = true
        var query = ENDPOINT + 'v1/managedevices/' + this.$route.params.id
        AXIOSAPI.get(query, {}).then((response) => {
          this.item = response.data
          if (this.item.config.applications === null) {
            this.item.config.applications = []
          }
          if (this.item.notificationEmails === null) {
            this.item.notificationEmails = []
          }
          this.loading = false
        })
      },

      showAddPackage: function () {
        this.newPackage.uri = ''
        this.newPackage.app_version = ''
        this.newPackage.package = ''
        this.newPackage.appkey = ''
        this.newPackage.config.kioskMode = false

        this.showAddDialog = true
      },

      addPackage: function () {
        this.showAddDialog = false
        var query2 = ENDPOINT + 'v1/managedevices/' + this.item.id + '/config/app'
        AXIOSAPI.post(query2, this.newPackage).then(response => {
          this.newPackage = this.emptyPackage
          console.log('Getting new data')
          this.getData()
        }).catch(e => {
          this.errorText = 'Add failed: ' + e
        })
      },

      saveConfig: function () {
        var query = ENDPOINT + 'v1/managedevices/' + this.item.id + '/config'
        AXIOSAPI.post(query, this.item.config).then(response => {
          this.getData()
        }).catch(e => {
          this.errorText = 'Config failed: ' + e
        })
      },

      deletePackage: function (packageName, key) {
        this.loading = true
        this.deleteAppPackage = packageName
        this.deleteAppKey = key
        var query = ENDPOINT + 'v1/managedevices/' + this.item.id + '/config/app/' + key + '/delete'
        AXIOSAPI.post(query, {}).then(response => {
          this.getData()
          this.showDeleteAppDialog = true
        }).catch(e => {
          this.errorText = 'Delete failed: ' + e
        })
      },

      uninstallPackage: function (key) {
        this.loading = true
        var query = ENDPOINT + 'v1/managedevices/' + this.item.id + '/config/app/' + this.deleteAppPackage + '/uninstall'
        AXIOSAPI.post(query, {}).then(response => {
          this.deleteAppKey = ''
          this.deleteAppPackage = ''
          this.loading = false
          this.showDeleteAppDialog = false
        }).catch(e => {
          this.errorText = 'Delete failed: ' + e
        })
      },

      editPackage: function (app) {
        this.newPackage.uri = app.uri
        this.newPackage.app_version = app.app_version
        this.newPackage.package = app.package
        this.newPackage.appkey = app.appkey
        this.newPackage.config.kioskMode = app.config.kioskMode
        this.showAddDialog = true
      },

      pushConfig: function () {
        this.loading = true
        var query = ENDPOINT + 'v1/managedevices/' + this.item.id + '/config/push'
        AXIOSAPI.post(query, {}).then(response => {
          this.getData()
        }).catch(e => {
          this.errorText = 'Push failed: ' + e
        })
      },

      refreshLogs: function () {
        this.logsLoadData = false
        setTimeout(() => {
          this.logsLoadData = true
        }, 10)
      },

      requestHeartbeat: function () {
        var query = ENDPOINT + 'v1/managedevices/' + this.item.id + '/heartbeat'
        AXIOSAPI.post(query, {}).then(response => {
          this.getData()
        }).catch(e => {
          this.errorText = 'Heartbeat request failed: ' + e
        })
      },

      saveName: function () {
        this.loading = true
        var query1 = ENDPOINT + 'v1/managedevices/' + this.item.id + '/config/name'
        AXIOSAPI.post(query1, this.item).then(response => {
          this.loading = false
        })
      },

      requestLogs: function () {
        var query = ENDPOINT + 'v1/managedevices/' + this.item.id + '/sendlogs'
        this.loading = true
        AXIOSAPI.post(query, this.item).then(response => {
          // this.loading = false
          setTimeout(() => {
            this.refreshLogs()
          }, 1000)
        })
      },

      requestADBState: function (newState) {
        var query = ENDPOINT + 'v1/managedevices/' + this.item.id + '/adb'
        this.loading = true
        AXIOSAPI.post(query, {adbEnabled: newState}).then(response => {
          this.loading = false
        })
      },

      requestReboot: function () {
        var query = ENDPOINT + 'v1/managedevices/' + this.item.id + '/reboot'
        this.loading = true
        AXIOSAPI.post(query, this.item).then(response => {
          this.loading = false
        })
      },

      addEmail: function (newEmail) {
        if (this.item.notificationEmails == null) {
          this.item.notificationEmails = []
        }
        if (this.item.notificationEmails.indexOf(newEmail) === -1) {
          this.item.notificationEmails.push(newEmail)
        }
        this.showEmailDialog = false

        this.updateEmails()
      },

      deleteEmail: function (targetEmail) {
        const index = this.item.notificationEmails.indexOf(targetEmail)
        if (index >= 0) {
          this.item.notificationEmails.splice(index, 1)

          this.updateEmails()
        }
      },

      updateEmails: function () {
        var query = ENDPOINT + 'v1/managedevices/' + this.item.id + '/emails'
        AXIOSAPI.post(query, {emails: this.item.notificationEmails}).then(response => {
          this.newEmail = ''
          setTimeout(this.getData, 500)
        }).catch(e => {
          this.errorText = 'Add failed: ' + e
        })
      }
    }
  }
</script>

<style scoped>
  #addButton {
    position: relative;
    overflow: hidden;
    position: fixed;
    bottom: 80px;
    right: 20px;
  }

  #buttonColumn {
    padding: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/DeviceEdit.vue